import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import { exhibitorsApi } from '@/shared/api/exhibitorsApi';
import type { DashboardDto } from '@/shared/types/domain';

export const dashboardApi = {
  getExhibitor: exhibitorsApi.getById,
  getDashboard: (eventId: string) => httpClient.get<DashboardDto>(endpoints.dashboard.get(eventId))
};
